export default __webpack_public_path__ + "static/media/wSkirt_1_p2.5779cd02.jpeg";